import moment from "moment";
import "moment/locale/pt-br";

moment.locale("pt-BR");
function formatBr(cell, row, index, excel = false) {
  if (cell) {
    let date = new Date(cell);
    if (excel) {
      return moment(date);
    }
    return moment(date).format("L");
  }

  return null;
}
export default formatBr;
